import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "You have been invited to join", -1)
const _hoisted_3 = {
  key: 0,
  class: "py-4"
}
const _hoisted_4 = { class: "font-bold text-4xl" }
const _hoisted_5 = { class: "py-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Join ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" other players in this Faction ")
const _hoisted_8 = { class: "space-x-4" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Accept")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Decline")

import { apiFactions } from '@/api/faction';
import { Faction } from '@/typings/faction';
import FactionImage from '@/components/Faction/FactionImage.vue';
import { ref } from 'vue';
import Button from '@/components/UI/Button.vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/store/users';
import { apiBrands } from '@/api/brand';


export default /*#__PURE__*/_defineComponent({
  props: {
    uuid: null
  },
  setup(__props: any) {

const props = __props as {
  uuid: string;
}



const router = useRouter();

const faction = ref<Faction>();

async function initialise() {
  const brand = await (
    await apiBrands.getBrands()
  ).data.find((b) => b.Uuid == props.uuid);
  if (!brand) {
    router.push('/scorecards');
    return;
  }

  faction.value = await (
    await apiFactions.getFaction(brand.LinkedFaction)
  ).data;

  if (faction.value.Joined) {
    router.push(`/faction/${faction.value.Uuid}`);
  }
}

function onDecline() {
  router.push('/scorecards');
}

async function onAccept() {
  const userStore = useUserStore();
  if (!userStore.user) {
    router.push(`/login`);
    return;
  }
  await apiFactions.join(userStore.user, faction.value?.JoinCode ?? '');
  router.push(`/faction/${faction.value?.Uuid}`);
}

initialise();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (faction.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(FactionImage, {
            faction: faction.value,
            class: "w-40 h-40"
          }, null, 8, ["faction"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, _toDisplayString(faction.value?.Name), 1),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("b", null, _toDisplayString(faction.value?.MemberCount), 1),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(Button, { onClick: onAccept }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(Button, { onClick: onDecline }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ])
  ]))
}
}

})